exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "legend-display .legend .legend-item {\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\nlegend-display .legend.vertical .legend-item {\n  display: -ms-flexbox;\n  display: flex; }\n\nlegend-display .legend .legend-item {\n  -ms-flex-align: center;\n      align-items: center;\n  margin-left: 5px; }\n  legend-display .legend .legend-item:first-child {\n    margin-left: 0px; }\n  legend-display .legend .legend-item .item-icon {\n    display: inline-block;\n    height: 16px;\n    width: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/legend-display/legend-display.component.scss
// module id = ../../../../../src/app/component-module/legend-display/legend-display.component.scss
// module chunks = main